import { JSX } from 'react'

import { IconProps } from '../../icon'

const Support: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M41 27.641C41 24.6708 38.8831 22.1764 36.0769 21.6185V21.0769C36.0769 14.9723 31.1046 10 25 10C18.8954 10 13.9231 14.9723 13.9231 21.0769V21.6185C11.1169 22.1928 9 24.6708 9 27.641C9 31.0379 11.7569 33.7949 15.1538 33.7949H16.7949C19.2892 33.7949 21.3077 31.7764 21.3077 29.2821V26C21.3077 23.5056 19.2892 21.4872 16.7949 21.4872H16.3846V21.0769C16.3846 16.3179 20.241 12.4615 25 12.4615C29.759 12.4615 33.6154 16.3179 33.6154 21.0769V21.4872H33.2051C30.7108 21.4872 28.6923 23.5056 28.6923 26V29.2821C28.6923 31.7764 30.7108 33.7949 33.2051 33.7949H33.6154V34.2051C33.6154 35.3374 32.6964 36.2564 31.5641 36.2564H28.2821C27.6092 36.2564 27.0513 36.8144 27.0513 37.4872C27.0513 38.16 27.6092 38.7179 28.2821 38.7179H31.5641C34.0585 38.7179 36.0769 36.6995 36.0769 34.2051V33.6636C38.8831 33.0892 41 30.6113 41 27.641ZM18.8462 26V29.2821C18.8462 30.4144 17.9272 31.3333 16.7949 31.3333H15.1538C13.119 31.3333 11.4615 29.6759 11.4615 27.641C11.4615 25.6062 13.119 23.9487 15.1538 23.9487H16.7949C17.9272 23.9487 18.8462 24.8677 18.8462 26ZM34.8462 31.3333H33.2051C32.0728 31.3333 31.1538 30.4144 31.1538 29.2821V26C31.1538 24.8677 32.0728 23.9487 33.2051 23.9487H34.8462C36.881 23.9487 38.5385 25.6062 38.5385 27.641C38.5385 29.6759 36.881 31.3333 34.8462 31.3333Z'
      fill='black'
    />
  </svg>
)

export default Support
